import { atom } from 'jotai';

/**
 * stores the public key
 */
export const publicKeyAtom = atom<string>('');
